import axios from "axios";
import axiosInstance from "../utils/axios-instance";

export const listSupportCenter = async (token: string) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/support/list`
  );
  return response.data;
};

export const updateSupportCenter = async (token: string, data: object) => {
  const response = await axiosInstance.patch(
    `${process.env.REACT_APP_API_BASE_URL}/cms/support`,
    data
  );
  return response.data;
};
